export default (function (response, json) {
  return Promise.reject({
    message: "Fetch request failed with status: ".concat(json.Status),
    response: response,
    json: json
  });
});